<template>
  <div class="benefit-wrap">
    <div class="benefit-desc-wrap text-center">
      <p>{{ $t('landing.exp.whyG.1') }}</p>
      <p>{{ $t('landing.exp.whyG.2') }}</p>
      <p>{{ $t('landing.exp.whyG.3') }}</p>
      <p>{{ $t('landing.exp.whyG.subtitle1.desc') }}</p>
      <p>{{ $t('landing.exp.whyG.subtitle2.desc') }}</p>
      <p class="text-center">{{ $t('landing.exp.whyG.4') }}</p>
    </div>

    <ul class="benefit-list">
      <li class="my-8" v-for="(item, index) in list" :key="index">
        <div class="benefit-list-icon">
          <img :src="item.icon" alt />
        </div>
        <div class="benefit-list-content">
          <div class="benefit-list-title">{{ item.title }}</div>
          <div class="benefit-list-desc">{{ item.desc }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Benefit',
  components: {},
  data() {
    return {
      currentCoin: 'GRX',
      list: [
        {
          icon: require('@/assets/images/home/exprience_1.png'),
          title: this.$t('landing.exp.sec.1'),
          // zh_CN: 为所有加密交易需求的一站式解决方案中心
          desc: this.$t('landing.exp.desc.1')
          // zh_CN: 提供多种交易选项和最受欢迎的交易对
        },
        /*{
          icon: require('@/assets/images/home/exprience_2.png'),
          title: this.$t('landing.exp.sec.2'),
          // zh_CN: 镇上最低的交易手续费
          desc: this.$t('landing.exp.desc.2')
          // zh_CN: 高竞争力的交易手续费，低至0.04％
        },
        {
          icon: require('@/assets/images/home/exprience_3.png'),
          title: this.$t('landing.exp.sec.3'),
          // zh_CN: 全面加盟会员计划
          desc: this.$t('landing.exp.desc.3')
          // zh_CN: 通过活跃推荐者获取20％的被动佣金收入
        },*/
        {
          icon: require('@/assets/images/home/exprience_4.png'),
          title: this.$t('landing.exp.sec.4'),
          // zh_CN: 优质的平台安全功能
          desc: this.$t('landing.exp.desc.4')
          // zh_CN: 与CipherTrace®和World-Check系统整合
        },
        {
          icon: require('@/assets/images/home/exprience_5.png'),
          title: this.$t('landing.exp.sec.5'),
          // zh_CN: 全天候（24/7）客户支持服务
          desc: this.$t('landing.exp.desc.5')
          // zh_CN: 提供快速响应时间的高效客户服务
        }
      ]
    };
  },
  methods: {}
};
</script>
<style lang="stylus" scoped>
.benefit-wrap {
  margin: 0 auto;
  max-width: 1200px;

  .benefit-desc-wrap {
    color: #555555;
    font-size: 14px;
    margin: 55px auto;
    max-width: 900px;
    padding: 0 15px;
    line-height: 19px;
  }

  .benefit-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0 15px 70px !important;

    > li {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      text-overflow: ellipsis;
      justify-content: flex-start;
      max-width: 380px;
      width: 100%;

      .benefit-list-icon {
        text-align: center;
        margin-bottom: 20px;
        min-height: 110px;
        max-height: 110px;

        > img {
          max-width: 130px;
          max-height: 105px;
        }
      }

      .benefit-list-content {
        min-height: 35px;

        //   .benefit-title {
        //     font-size: 30px;
        //     line-height: 40px;
        //     color: rgba(85, 85, 85, 1);
        //     text-align: center;
        //     padding-top: 80px;
        //     padding-bottom: 5px;
        //   }

        .benefit-list-title {
          text-align: center;
          font-size: 20px;
          /* line-height: 60px; */
          font-weight: bold;
          margin-bottom: 5px;
        }

        .benefit-list-desc {
          padding: 0 20px;
          text-align: center;
          /* height: 100px; */
          font-size: 14px;
          color: rgba(85, 85, 85, 1);
          opacity: 1;
        }
      }
    }
  }
}

//   .benefit-view-all {
//     text-align: center;
//     font-size: 14px;
//     color: rgba(85, 85, 85, 1);
//     padding-top: 10px;
//   }

//   padding: 0 50px;
// }
</style>
